module.exports = __webpack_public_path__ + "img/sc_img.daab4d95.png";